<template>
  <div v-if="value === null">
    <span class="price-text">{{ ' – ' }}</span>
  </div>
  <div v-else class="flex">
    <div v-if="editMode">
      <CpcInput v-if="isCpc" :value="value" @change="$emit('change', $event)" />
      <CpaInput v-else :value="value" @change="$emit('change', $event)" />
      <span class="input-postfix">{{ inputPostfix }}</span>
    </div>
    <div v-else>
      <span class="price-text">{{ priceText }}</span>
    </div>
    <DiffText :cost="value" :base-cost="baseCost" :type="type" :class="'diff-text'" />
  </div>
</template>

<script lang="ts">
import CpaInput from './CpaInput.vue'
import CpcInput from './CpcInput.vue'
import DiffText from './DiffText.vue'

import { formatMoney, getCurrencySymbol } from '@/legacy/store/helpFunctions'

export default {
  name: 'Cost',
  components: {
    CpcInput,
    CpaInput,
    DiffText,
  },
  // eslint-disable-next-line vue/no-deprecated-model-definition
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    type: { type: String, validator: (t) => t === 'cpc' || t === 'cpa' },
    editMode: Boolean,
    baseCost: Number,
    value: Number,
  },
  emits: ['change'],
  computed: {
    currencyPerClickLabel: function () {
      return getCurrencySymbol() + '/click'
    },
    isCpc() {
      return this.type === 'cpc'
    },
    inputPostfix() {
      return this.isCpc ? this.currencyPerClickLabel : '%'
    },
    priceText() {
      return this.isCpc ? formatMoney(this.value) + '/click' : this.value + '%'
    },
  },
  methods: {
    formatMoney,
  },
}
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  align-items: center;
}

.input-postfix {
  margin-left: 12px;
}

.price-text {
  color: #000;
  font-size: 18px;
  font-weight: 500;
  line-height: 40px;
}

.diff-text {
  line-height: 40px;
  margin-left: 8px;
}
</style>
